import * as S from './styles'

interface BarGraphProps {
  percentValue: number
}

export const BarGraph: React.FC<BarGraphProps> = ({ percentValue }) => {
  const getFillColor = (value: number) => {
    if (value < 50) return '#FF4842'
    if (value >= 50 && value < 85) return '#FF8D23'
    if (value >= 85 && value < 100) return '#FFC107'
    return '#54D62C'
  }

  const formatValue = (value: number) => {
    return Number(value.toFixed(1))
  }

  return (
    <S.Wrapper>
      <S.ProgressBar>
        <S.ProgressFill
          color={getFillColor(percentValue)}
          progress={percentValue <= 100 ? percentValue : 100}
        />
      </S.ProgressBar>
      <S.GraphText progress={percentValue}>
        {formatValue(percentValue)}% da meta
      </S.GraphText>
    </S.Wrapper>
  )
}
